import EntityBaseRepository from '@/api/EntityBaseRepository';
import {AxiosResponse} from 'axios';
import {Maintenance} from "@/models/maintenance";
import { serializeMaintenanceList } from '@/utils/maintenanceListUtils';

export default class MaintenanceRepository extends EntityBaseRepository {
    public updateMaintenance(maintenance: Maintenance): Promise<AxiosResponse> {
        const maintenanceCopy = Object.assign({}, maintenance);
        delete maintenanceCopy.maintenanceImages;
        if (maintenanceCopy.maintenanceList) {
            maintenanceCopy.maintenanceList = serializeMaintenanceList(maintenanceCopy.maintenanceList) as any;
        }
        const maintenanceId = maintenance.id || (maintenance as any)._id;
        return this.axiosClient.patch(`/maintenance/${maintenanceId}`, maintenanceCopy);
    }

    public deleteMaintenance(maintenanceId: string): Promise<AxiosResponse> {
        return this.axiosClient.delete(`/maintenance/${maintenanceId}`);
    }

    public generatePDF(maintenanceId: string, options: any): Promise<any> {
        const language = options.language === 'en' ? 'en' : 'de';
        const withImages = options.withImages ? 'true' : 'false';
        return this.axiosClient.get(
            `/maintenance/${maintenanceId}/generatePDF?withImages=${withImages}&language=${language}`,
            { responseType: 'arraybuffer' }
        );
    }

    public generateMultiplePDF(maintenances: string[], options: any): Promise<any> {
        return this.axiosClient.get(`maintenance/${JSON.stringify(maintenances)}/generateMultiplePDF${options.withImages ? "?withImages=true" : "?withImages=false"}&language=${options.language}`, {
            responseType: 'arraybuffer'
        });


    }

    public getMaintenancesByMachine(machineId: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`maintenance/machine/${machineId}`);
    }

    /**
     * Creates the NEW Maintenance instance for a machine
     * @param machineId - The id of the machine
     * @param maintenanceData - The data for the maintenance instance
     * @returns The created maintenance instance
     */
    public createMaintenance(machineId: string, maintenanceData: any): Promise<AxiosResponse> {
        return this.axiosClient.post(`maintenance?machine=${machineId}`, maintenanceData);
    }

}
